import Component from '../Component';
import * as eventNames from '../../customEventStrings';
import * as uiStrings from '../../uiStrings';

class SidePanelButton extends Component {
	constructor() {
		super();
	}

	componentDidMount() {
		this.setupEventListeners();
	}

	setupEventListeners() {
		this.refs['sidepanel-button'].addEventListener('click', () => {
			this.dispatchCustomEvent(eventNames.OPEN_SIDE_PANEL, this.refs['sidepanel-button']);
		});
	}

	render() {
		return `
            <div ref="sidepanel-button" class="control-button sidepanel--button">
                <div class="control-button__icon" title="${uiStrings.INFO_LINKS}">
                    <i class="fas fa-info fa-2x"></i>
                </div>
            </div>
        `;
	}
}

export default SidePanelButton;
